import { render, staticRenderFns } from "./select-work-type.vue?vue&type=template&id=1ca76b98&"
import script from "./select-work-type.vue?vue&type=script&lang=js&"
export * from "./select-work-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports